<template>
    <div class="card mt-2" style="margin-bottom:10px">

        <div class=" card-body">


            <div class="registro-head">
                <div>
                    <h6>Registro de pacientes</h6>
                    <p v-if="!creacion && !loading">{{ pacientesVisibles.length }} registrados</p>
                </div>
                <div class="registro-tools">
                    <input v-if="!creacion" type="text" class="registro-buscar" placeholder="Buscar por nombre o cédula"
                        @input="programarBusqueda" />
                    <button v-if="!creacion && !loading" type="button" class="btn-refrescar" @click="refresh"
                        aria-label="Actualizar listado">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button class="btn btn-primary btn-sm" @click="irAcrearPaciente()">
                        {{ agregarPaciente }}
                    </button>
                </div>
            </div>



            <div v-if="creacion">
                <creacion-pacientes :title="titleButton" :enviarsend="enviarDatos"
                    @carga-pacientes="loadPacientesAll" />
            </div>


            <div v-show="!creacion">

                <div v-if="loading" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding:0px">

                    <div class="row">

                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">

                            <Skeletor :shimmer="true" height="40" width="50%" />

                        </div>

                        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">

                            <Skeletor :shimmer="true" height="10" pill width="30%" style="margin-bottom: 10px;" />
                            <Skeletor :shimmer="true" height="40" width="100%" />

                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <table class="table tablesorter">
                                <thead class="thead-light">
                                    <tr>
                                        <th>
                                            <Skeletor :shimmer="true" height="10" width="100%" />
                                        </th>
                                        <th>
                                            <Skeletor :shimmer="true" height="10" width="100%" />
                                        </th>
                                        <th>
                                            <Skeletor :shimmer="true" height="10" width="100%" />
                                        </th>
                                        <th>
                                            <Skeletor :shimmer="true" height="10" width="100%" />
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>


                                    <tr>

                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>






                                    </tr>
                                    <tr>

                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>






                                    </tr>
                                    <tr>

                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>
                                        <td>
                                            <Skeletor :shimmer="true" height="20" width="100%" />
                                        </td>






                                    </tr>

                                </tbody>
                            </table>

                        </div>

                        <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
                            <Skeletor :shimmer="true" height="10" pill width="80%" />
                        </div>

                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">

                            <div class="row">
                                <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <Skeletor :shimmer="true" height="10" width="100%" />
                                </div>

                                <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" align="center">
                                    <Skeletor :shimmer="true" circle size="30" />
                                </div>

                                <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <Skeletor :shimmer="true" height="10" width="100%" />
                                </div>


                            </div>


                        </div>

                    </div>

                </div>

                <div v-else class="pacientes-tabla">
                <DataTable :columns="columns" :options="options" :data="pacientesVisibles"
                    class="table tablesorter pacientes-table" width="100%">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Creación</th>
                            <th data-priority="1">Nombre</th>
                            <th>Edad</th>
                            <th data-priority="2">Móvil</th>
                            <th data-priority="3">Registrado por</th>
                            <th class="text-center">Acciones</th>
                        </tr>
                    </thead>





                </DataTable>
                </div>
            </div>



        </div>

    </div>
</template>
<script>
/* eslint-disable */

import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';
DataTable.use(DataTablesCore);

import CreacionPacientes from './Creacion.vue';

import $ from "jquery";

export default {
    components: {

        DataTable,
        CreacionPacientes

    },

    data() {
        return {
            loading: true,
            creacion: false, //oculta creacion
            titleButton: 'Registrar',
            enviarDatos: null,
            tokenAuth: '',
            isMobile: this.$isMobile,
            busquedaAplicada: '',
            busquedaTimer: null,
            resultadoTimer: null,
            cargaId: 0,
            transactions: [],
            columns: [
                { data: null, render: (data, type, row, meta) => meta.row + 1 },
                {
                    data: 'created_at',
                    render: (data, type) => {
                        if (!data) return '';
                        const valor = new Date(data);
                        if (Number.isNaN(valor.getTime())) return '';
                        const fecha = new Intl.DateTimeFormat('es-EC', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        }).format(valor);
                        const hora = new Intl.DateTimeFormat('es-EC', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        }).format(valor);
                        if (type && type !== 'display') return `${fecha} ${hora}`;
                        return `
                            <div class="paciente-celda">
                                <span class="paciente-nombre-tabla">${fecha}</span>
                                <span class="paciente-cedula-tabla">${hora}</span>
                            </div>
                        `;
                    }
                },
                {
                    data: null,
                    render: (data, type) => {
                        const nombre = data.nombre_completo || '';
                        if (type && type !== 'display') return nombre;
                        const cedula = data.cedula || '';
                        return `
                            <div class="paciente-celda">
                                <span class="paciente-nombre-tabla">${nombre}</span>
                                <span class="paciente-cedula-tabla">${cedula}</span>
                            </div>
                        `;
                    }
                },
                { data: null, render: (data) => this.calcularEdad(data.nacimiento) },
                { data: 'celular' },
                { data: 'usuario' },
                {
                    data: null,
                    render: function (data, type, row) {
                        const dataObject = encodeURIComponent(JSON.stringify(row)); // Codificar el JSON 
                        return `
                <div class="acciones-paciente">
                    <i data-id="${dataObject}" data-action="ver" class="dataAction accion accion-ver fas fa-briefcase-medical" data-type="ver" title="Ver"></i>
                    <i data-id="${dataObject}" data-action="edit" class="dataAction accion accion-editar fas fa-pen" data-type="modificar" title="Editar"></i>
                    <i data-id="${dataObject}" data-action="delete" class="dataAction accion accion-eliminar fas fa-trash-alt" data-type="delete" title="Eliminar"></i>
                </div>
            `;
                    }
                }
            ],
            options: {
                searching: false,
                responsive: true,
                autoWidth: false,
                lengthChange: false,
                ordering: false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: 4 }
                ],

                pageLength: 20,
                language: {
                    search: "Buscar:",
                    sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
                    searchPlaceholder: "Ingrese algún dato",
                    zeroRecords: "Lo sentimos, no se encontraron resultados",
                    processing: "Buscando. Espere por favor...",
                    sLengthMenu: "Mostrar _MENU_ registros",
                    oPaginate: {
                        sFirst: "Primero",
                        sLast: "Último",
                        sNext: "Siguiente",
                        sPrevious: "Anterior"
                    }
                }
            }

        }
    },
    activated() {

        if (this.isMobile) {
            this.$eventBus.emit('activeShowMenu')
        }




    },

    computed: {
        agregarPaciente() {
            return this.creacion ? 'Lista' : 'Nuevo';
        },
        pacientesVisibles() {
            const texto = String(this.busquedaAplicada || '').trim();
            const consulta = this.normalizar(texto);
            if (consulta.length < 2) return this.transactions;

            const palabras = consulta.split(/\s+/).filter(Boolean);

            return this.transactions.filter((paciente) => {
                const nombre = this.normalizar(paciente.nombre_completo);
                const cedula = String(paciente.cedula || '');
                if (cedula.includes(texto)) return true;
                return palabras.every((palabra) => nombre.includes(palabra));
            });
        }
    },

    methods: {
        programarBusqueda(event) {
            const valor = event.target.value;
            clearTimeout(this.busquedaTimer);
            clearTimeout(this.resultadoTimer);

            this.busquedaTimer = setTimeout(() => {
                this.loading = true;
                this.resultadoTimer = setTimeout(() => {
                    this.busquedaAplicada = valor;
                    this.loading = false;
                }, 700);
            }, 4000);
        },

        normalizar(texto) {
            return String(texto || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
        },

        calcularEdad(fechaNacimiento) {
            let hoy = new Date();
            let fechaNace = new Date(fechaNacimiento);
            let edad = hoy.getFullYear() - fechaNace.getFullYear();
            if (hoy.getMonth() < fechaNace.getMonth() ||
                (hoy.getMonth() === fechaNace.getMonth() && hoy.getDate() < fechaNace.getDate())) {
                edad--;
            }
            return edad;
        },

        refresh() {
            this.loading = true
            this.loadPacientesAll()

        },

        loadPacientesAll() {
            const cargaId = ++this.cargaId;

            this.$https.post('/pacientes/getLoadPacientes', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                if (cargaId !== this.cargaId) return;

                this.loading = false;

                if (response.data.code === 200) {

                    this.transactions = response.data.datos

                } else {
                    this.transactions = []
                }


            }).catch(error => {
                if (cargaId !== this.cargaId) return;

                this.loading = false;

                this.$toast.error("Ocurrió un error inesperado", {
                    position: "top-right",
                    max: 10
                })


                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert()
                }



            })



        },

        irAcrearPaciente() {
            if (this.creacion) {
                this.creacion = false;
                this.enviarDatos = null;
                this.titleButton = 'Registrar';
                this.$nextTick(() => window.dispatchEvent(new Event('resize')));
                return;
            }

            this.enviarDatos = null;
            this.titleButton = 'Registrar';
            this.creacion = true;
        },

        ifAPerfilPaciente(data) {

            this.$router.push({ name: 'perfilPaciente', params: { id: data } });
        },

        sendDatosEdit(data) {
            this.enviarDatos = data;
            this.titleButton = 'Editar';
            this.creacion = true;
        },

    },

    mounted() {

        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }



        this.tokenAuth = localStorage.getItem("tokenAuth")

        const vm = this;

        $(document).off("click", ".dataAction");
        $(document).on("click", ".dataAction", function (evt) {
            const dataString = $(this).data("id");
            const actionType = $(this).data('type'); // Tipo de acción: 'pdf', 'edit' o 'delete'

            try {

                const data = JSON.parse(decodeURIComponent(dataString)); // Decodificar y parsear JSON

                if (actionType === "modificar") {
                    vm.sendDatosEdit(data)
                } else if (actionType === "ver") {
                    vm.ifAPerfilPaciente(data.cod_paciente)
                } else if (actionType === "delete") {
                    console.log('Ingresa a Eliminar');
                }

            } catch (e) {
                console.error("Error al parsear el JSON:", e);
            }
        });



        this.loadPacientesAll()

    },

    beforeUnmount() {
        clearTimeout(this.busquedaTimer);
        clearTimeout(this.resultadoTimer);
    },



}

</script>

<style lang="scss">
@import "datatables.net-dt";
@import 'datatables.net-responsive-dt';

.registro-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
}

.registro-head h6 {
    margin: 0;
    color: #1f2a37;
    font-weight: 700;
}

.registro-head p {
    margin: 2px 0 0;
    color: #6b7c8f;
    font-size: 0.78rem;
}

.registro-tools {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.registro-buscar {
    width: min(280px, 46vw);
    border: 1px solid #e3eaf2;
    border-radius: 10px;
    padding: 7px 12px;
    background: #f4f7fb;
    color: #1f2a37;
    font-size: 0.85rem;
}

.registro-buscar:focus {
    outline: none;
    border-color: #0078be;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(0, 120, 190, 0.12);
}

.btn-refrescar {
    width: 34px;
    height: 34px;
    border: 1px solid #e3eaf2;
    border-radius: 10px;
    background: #fff;
    color: #0078be;
}

.pacientes-tabla {
    border: 1px solid #e6edf5;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
}

.pacientes-tabla .dataTables_wrapper {
    padding: 0 0 8px;
}

.pacientes-tabla table.pacientes-table {
    margin: 0 !important;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 0.84rem;
    color: #1f2a37;
}

.pacientes-tabla table.pacientes-table thead th {
    padding: 12px 10px;
    border-bottom: 1px solid #e6edf5 !important;
    background: #f4f8fb;
    color: #4b5d6e;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.pacientes-tabla table.pacientes-table tbody td {
    padding: 11px 10px;
    border-top: 0;
    border-bottom: 1px solid #eef2f6;
    vertical-align: middle;
}

.pacientes-tabla table.pacientes-table tbody tr:hover td {
    background: #f3f9fd;
}

.paciente-celda {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.paciente-nombre-tabla {
    font-weight: 700;
    line-height: 1.2;
}

.paciente-cedula-tabla {
    color: #6b7c8f;
    font-size: 0.75rem;
}

.acciones-paciente {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
}

.accion {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: inline-grid;
    place-items: center;
    cursor: pointer;
    font-size: 0.75rem;
}

.accion-ver,
.accion-editar {
    background: #e8f4fc;
    color: #0078be;
}

.accion-eliminar {
    background: #fde8f0;
    color: #eb1265;
}

.accion:hover {
    filter: brightness(0.96);
}

.pacientes-tabla .dataTables_info {
    padding: 10px 12px 4px;
    color: #6b7c8f;
    font-size: 0.75rem;
}

.pacientes-tabla .dataTables_paginate {
    padding: 6px 12px 8px;
}

.pacientes-tabla .dataTables_paginate .paginate_button {
    margin: 0 2px;
    border: 1px solid #e3eaf2 !important;
    border-radius: 8px !important;
    background: #fff !important;
    color: #0078be !important;
}

.pacientes-tabla .dataTables_paginate .paginate_button.current {
    background: #0078be !important;
    border-color: #0078be !important;
    color: #fff !important;
}

.pacientes-tabla .dataTables_paginate .paginate_button.disabled {
    color: #c5d0db !important;
}

@media (max-width: 768px) {
    .registro-head {
        align-items: stretch;
        flex-direction: column;
    }

    .registro-tools {
        width: 100%;
    }

    .registro-buscar {
        flex: 1;
        width: auto;
    }
}
</style>